import React from "react";
import { BookOpen, Compass } from "lucide-react";

/**
 * Historical Reference + Why This Matters — the Context Layer.
 * Derived from vetted profile text; renders nothing when absent.
 */
export const LearningPanels = ({ entity }) => {
  const ref = entity?.historical_reference;
  const why = entity?.why_this_matters;
  if (!ref && !why) return null;
  return (
    <section
      className="max-w-6xl mx-auto px-4 md:px-8 pt-10 md:pt-12"
      data-testid="learning-panels"
    >
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {ref && (
          <div
            className="md:col-span-3 border p-5 md:p-6"
            style={{ borderColor: "#2D2A26", background: "#0F0E12" }}
            data-testid="historical-reference"
          >
            <div className="flex items-center gap-2 mb-3">
              <BookOpen size={12} className="text-[#A68F5E]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.45em] text-[#A68F5E]">
                Historical Reference
              </span>
            </div>
            <p className="text-[14px] md:text-[15px] text-[#C9C3B5] leading-relaxed">
              {ref}
            </p>
          </div>
        )}
        {why && (
          <div
            className="md:col-span-2 border p-5 md:p-6"
            style={{ borderColor: "#2D2A26", background: "#12110E" }}
            data-testid="why-this-matters"
          >
            <div className="flex items-center gap-2 mb-3">
              <Compass size={12} className="text-[#D92D20]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.45em] text-[#D92D20]">
                Why This Matters
              </span>
            </div>
            <p className="text-[13px] text-[#A39E93] leading-relaxed">
              {why}
            </p>
          </div>
        )}
      </div>
    </section>
  );
};
